import { IPluginConfiguration } from "../../models/configuration/plugin/IConfiguration";
import { Action, ActionType } from "../actions";

interface ConfigPluginDataState {
    loading: boolean;
    error: string | null;
    data: IPluginConfiguration | null;
    persistedData: IPluginConfiguration | null;
    pushbackSyncPending: boolean;
}

const initialState = { loading: false, error: null, data: null, persistedData: null, pushbackSyncPending: false }

const clonePluginConfig = (payload: IPluginConfiguration | null): IPluginConfiguration | null => {
    if (!payload) return payload;
    return JSON.parse(JSON.stringify(payload)) as IPluginConfiguration;
};

const configPlugInReducer = (
    state: ConfigPluginDataState = initialState,
    action: Action
): ConfigPluginDataState => {

    switch (action.type) {
        // GET DATA
        case ActionType.GET_CONFIG_PLUGIN_DATA:  // This is the process of getting the data
            return { ...state, loading: true, error: null };
        case ActionType.GET_CONFIG_PLUGIN_DATA_FAILURE:
            return { ...state, loading: false, error: action.payload};
        case ActionType.GET_CONFIG_PLUGIN_DATA_SUCCESS:
            const persistedData = action.fromServer ? clonePluginConfig(action.payload) : state.persistedData;
            return {
                ...state,
                loading: false,
                error: null,
                data: action.payload,
                persistedData
            }

        // SAVE DATA    
        case ActionType.SAVE_CONFIG_PLUGIN_DATA:
            return { ...state, loading: true, error: null, data: state.data };
        case ActionType.SAVE_CONFIG_PLUGIN_DATA_FAILURE:
            return { ...state,  loading: false, error: action.payload, data: state.data }
        case ActionType.SAVE_CONFIG_PLUGIN_DATA_SUCCESS:
            return { ...state, loading: false, error: null, data: action.payload }
        case ActionType.SAVE_CONFIG_PLUGIN_DATA_PERSISTED:
            return { ...state, loading: false, error: null, data: action.payload, persistedData: clonePluginConfig(action.payload) }
        case ActionType.REVERT_CONFIG_PLUGIN_DATA:
            return {
                ...state,
                loading: false,
                error: null,
                data: clonePluginConfig(state.persistedData)
            }

        // PUSHBACK SYNC RETRY STATE
        case ActionType.SET_PUSHBACK_SYNC_PENDING:
            return {
                ...state,
                pushbackSyncPending: true
            }
        case ActionType.CLEAR_PUSHBACK_SYNC_PENDING:
            return {
                ...state,
                pushbackSyncPending: false
            }

        default:
            return state;
    }
};

export default configPlugInReducer;